<button
  [type]="type"
  [disabled]="pending || disabled"
  mat-flat-button
  [id]="id"
  [color]="color"
  class="whitespace-nowrap"
  [ngClass]="class"
  [class.compact-button]="compact"
>
  <ng-content></ng-content>
  <div *ngIf="pending" class="pending-layer">
    <mat-spinner [diameter]="16" [color]="color === 'primary' ? 'accent' : undefined"></mat-spinner>
  </div>
</button>
